import { CloseButton } from '@digital-retail/design-system';
import { ChevronLeftIcon } from '@digital-retail/design-system-icons';
import PropTypes from 'prop-types';
import { WithToggle } from '../../../utils/WithToggle';
import { noop } from '../../../utils/noop';
import { BackgroundOverlay } from '../BackgroundOverlay/BackgroundOverlay';
import { dialogStyles } from './Dialog.style';

const Dialog = ({ header, body, footer, animationDirection, showDialog, toggleState, isMenuActive }) => {
  const getClassName = () => {
    if (showDialog) {
      return `${animationDirection} ${animationDirection}-active`;
    }
    return `${animationDirection}`;
  };

  const hasFooterClassName = footer() ? '' : 'no-footer';
  return (
    <>
      <div
        role="button"
        tabIndex="0"
        onKeyDown={noop}
        className={`dialog ${getClassName()} ${hasFooterClassName}`}
        onClick={() => {
          header.onClose();
        }}
        data-testid="dialog"
      >
        <div
          role="button"
          tabIndex="0"
          onKeyDown={noop}
          className="dialog dialog-background"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <header className={header.headerClass || ''}>
            {header.title && <h1>{header.title}</h1>}
            <div className="actions">
              {isMenuActive && (
                <button type="button" className="back" onClick={header.hideActiveMenu}>
                  <ChevronLeftIcon boxSize="16px" />
                </button>
              )}
              <CloseButton id="testId-Dialog-close" onClick={header.onClose} />
            </div>
          </header>
          <div className="body">{body(toggleState)}</div>
          {footer && <div className="footer">{footer()}</div>}
        </div>
        <style jsx>{dialogStyles}</style>
      </div>
      {showDialog && <BackgroundOverlay shade="lighter" />}
    </>
  );
};

Dialog.defaultProps = {
  footer: noop,
  header: {},
  animationDirection: 'rightToLeft',
  showDialog: false,
  isMenuActive: false,
};

Dialog.propTypes = {
  toggleState: PropTypes.object.isRequired,
  header: PropTypes.object,
  body: PropTypes.func.isRequired,
  footer: PropTypes.func,
  animationDirection: PropTypes.oneOf(['rightToLeft']),
  showDialog: PropTypes.bool,
  isMenuActive: PropTypes.bool,
};

export { Dialog };
export default WithToggle(Dialog);
